"use client";
import { useI18n } from "@wojo/localization";
import { Image } from "@wojo/ui";
import cn from "clsx";
import styles from "./SuccessIcon.module.scss";

type SuccessIconProps = {
    className?: string;
};

export const SuccessIcon: React.FC<SuccessIconProps> = ({ className }) => {
    const { successIconDarkModeSrc, successIconLightModeSrc, successIconSize } =
        useI18n("account").account.sharedAssets;

    return (
        <div
            className={styles["image-wrapper"]}
            style={
                {
                    ["--size"]: `${successIconSize.l()}px`,
                } as React.CSSProperties
            }
        >
            <Image
                alt="Success"
                src={successIconDarkModeSrc.l()}
                className={cn(styles.image, styles["image--dark"], className)}
                height={successIconSize.l()}
                width={successIconSize.l()}
            />
            <Image
                alt="Success"
                src={successIconLightModeSrc.l()}
                className={cn(styles.image, styles["image--light"], className)}
                height={successIconSize.l()}
                width={successIconSize.l()}
            />
        </div>
    );
};
